<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/intelligent-outbound-call/table">智能外呼列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="任务描述"
                          prop="title">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="客户"
                          prop="customer_id">
              <remote-select style="width: 100%;"
                           v-model="form.customer_id"
                           filterable
                           remote
                           clearable
                           id-key="number"
                           keyword-key="name"
                           :label="customerLabel"
                           value-key="id"
                           placeholder="请输入客户名称/编号搜索"
                           :query-request="customerRemoteMethod"
                           @change="form.project_id=null"
                           :find-request="getCustomerInfoRemote">
              </remote-select>
            </el-form-item>
            <el-form-item label="项目"
                          prop="project_id">
              <remote-select
                :disabled="!form.customer_id"
                v-model="form.project_id"
                class="width-max"
                clearable
                id-key="number"
                label-key="name"
                value-key="id"
                placeholder="请输入项目名称/编号搜索"
                :query-request="projectRemoteMethod"
                :find-request="getProjectInfoRemote">
              </remote-select>
            </el-form-item>
            <el-form-item label="外呼模板"
                          prop="robot_tpl">
              <el-input v-model="form.robot_tpl"></el-input>
              <span style="font-size: 12px; color: #999">外呼模板为百度智能外呼平台标识项，如有疑问请联系产品技术部同事</span>
            </el-form-item>
            <el-form-item label="未拨打重试次数"
                          prop="retry_times">
              <el-input v-model="form.retry_times">
                <span slot="suffix">次</span>
              </el-input>
            </el-form-item>
            <el-form-item label="未拨打重试间隔"
                          prop="retry_duration">
              <el-input v-model="form.retry_duration">
                <span slot="suffix">分钟</span>
              </el-input>
            </el-form-item>
            <el-form-item label="客户信息导入"
                          prop="file">
              <el-upload
                  class="upload-demo"
                  drag
                  v-model="form.file"
                  :limit="1"
                  accept=".xlsx,.xls"
                  :on-remove="handleRemove"
                  :http-request="uploadRequest"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em> 只能上传xlsx,xls文件</div>
                <div class="el-upload__tip" slot="tip">
                  <span>Excel需要包含表头[任务ID，姓名，电话，变量字段]变量字段为百度智能外呼平台设置项。任务ID，姓名，电话不得为空。</span>
                  <el-button type="text" @click="onExportDemo" size="mini">下载Demo
                  </el-button>
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交
          </el-button>
          <el-button @click="onReload">取消</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../intelligent-outbound-call.rules.js'

export default {
  components: {},
  data () {
    return {
      id: 0,
      formRules: filter.copyJson(formRules),
      form: {
        title: '',
        customer_id: '',
        project_id: '',
        robot_tpl: '',
        retry_times: '',
        retry_duration: '',
        file: null,
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
        delete this.formRules.file
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getIntelligentOutboundCallDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
        this.form.customer_id = String(this.form.customer_id)
        this.form.project_id = String(this.form.project_id)
        this.form.retry_times = String(this.form.retry_times)
        this.form.retry_duration = String(Number(this.form.retry_duration) / 60)
      })
    },
    getForm () {
      let formData = new FormData()
      formData.append('title', this.form.title)
      formData.append('robot_tpl', this.form.robot_tpl)
      formData.append('customer_id', this.form.customer_id)
      formData.append('project_id', this.form.project_id)
      formData.append('retry_times', this.form.retry_times)
      formData.append('retry_duration', this.form.retry_duration * 60)
      if (this.form.file) {
        formData.append('file', this.form.file)
      }
      return formData
    },
    onSubmit () {
      this.form.customer_id = Number(this.form.customer_id)
      this.form.project_id = Number(this.form.project_id)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createIntelligentOutboundCallData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/intelligent-outbound-call/table/'})
        })
      })
    },
    update (id) {
      let formData = this.getForm()
      request.common('updateIntelligentOutboundCallData', {id, formData}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/intelligent-outbound-call/table/'})
        })
      })
    },
    uploadRequest (obj) {
      this.form.file = obj.file
    },
    handleRemove () {
      this.form.file = null
    },
    customerRemoteMethod (query) {
      return request.common('getCustomerTable', {keyword: query.name})
    },
    getCustomerInfoRemote () {
      return request.common('getCustomerDetail', {id: this.form.customer_id})
    },
    customerLabel (item) {
      return item.name + '/' + item.number
    },
    projectRemoteMethod (query) {
      return request.common('getProjectTable', {keyword: query.name, customerid: this.form.customer_id})
    },
    getProjectInfoRemote () {
      return request.common('getProjectDetail', {id: this.form.project_id})
    },
    onExportDemo () {
      request.common('robotcallSetting').then(({data}) => {
        window.location.href = data.demo_file_create_calltask
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/intelligent-outbound-call/pages/IntelligentOutboundCallForm.vue